<script>
export default {
  name: 'Buttons',
  props: {
    form: {
      type: Object,
      required: true,
    },
    buttons: {
      type: Array,
      required: true,
    },
    btnGroup: {
      type: Boolean,
      required: false,
      default: false
    }
  },
}
</script>

<template>
  <div class="form-buttons mt-3" :class="{ 'btn-group': btnGroup === true }">
    <button
      v-for="button in buttons"
      :key="button.id"
      :type="button.type"
      class="btn"
      :class="button.class"
      :disabled="button.disabled"
      @click="button.method(form)"
    >
    <i v-if="button.icon" :class="button.icon"></i>
    {{button.name}}</button>
  </div>
</template>